<template>
  <div class="table__th">
    <div class="table__th-inner">
      <span class="table__th-text">{{ tHeader.title }}</span>
      <span class="table__th-icons">
        <span class="table__th-icon" v-if="tHeader.isSorting">
          <img src="@/assets/images/icons/sort.svg" alt="sort" class="js-tooltip-icon"
            :data-id="'tooltip-id-' + tHeader.sorting.sortingTabs[0].sortingName">
        </span>
        <span class="table__th-icon" v-if="tHeader.isFilter">
          <img src="@/assets/images/icons/filter.svg" alt="filter" class="js-tooltip-icon"
            :data-id="'tooltip-id-' + tHeader.filters.filtersName">
        </span>
      </span>
    </div>
    <Sorting :style="tooltipElemCoord" :sorting="tHeader.sorting" v-if="tHeader.isSorting" @addOrdering="addOrdering" />
    <Filtration :style="tooltipElemCoord" :filters="tHeader.filters" v-if="tHeader.isFilter" @addFiltration="addFiltration" />
  </div>
</template>


<script>
  import Sorting from '@/components/Controlls/Sorting.vue'
  import Filtration from '@/components/Controlls/Filtration.vue'

  export default {
    components: {
      Sorting,
      Filtration
    },
    props: {
      tHeader: {
        type: Object,
        require: true
      },
    },
    data() {
      return {
        showSorting: false,
        tooltipElemCoord: {
          top: '3rem',
          left: '',
          right: ''
        },
      }
    },
    methods: {
      addOrdering(data) {
        let queryOption = this.$store.state.promocode.queryObject
        queryOption.ordering[data.queryGroup] = data.query
        queryOption.offset = null
        this.$store.dispatch('fetchPromocodes', queryOption)
      },
      addFiltration(data) {
        let queryOption = this.$store.state.promocode.queryObject
        queryOption.filters[data.queryGroup] = data.query
        queryOption.offset = null
        this.$store.dispatch('fetchPromocodes', queryOption)
      },
    }
  }
</script>

<style lang="scss" scoped>
.table__th {
  position: relative;
}

.table__th-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  white-space: nowrap;
}

.table__th-text {
  font-size: 1.2rem;
  color: #8A8C96;
  font-weight: 500;
}

.table__th-icons {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.2rem;
}

.table__th-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  img {
    width: 1.4rem;
    height: 1.4rem;
    opacity: 0.6;
    transition: opacity 0.2s;

    &:hover {
      opacity: 1;
    }
  }
}
</style>
